import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
    0% {
        background-position: -468px 0;
    }
    100% {
        background-position: 468px 0;
    }
`;

export const SkeletonLine = styled.div`
    height: 20px;
    background: linear-gradient(
        90deg,
        #f0f0f0 25%,
        #e0e0e0 50%,
        #f0f0f0 75%
    );
    background-size: 468px 100%;
    animation: ${shimmer} 1.5s infinite;
    border-radius: 4px;
    margin: 8px 0;
`;